import { UserService, AuthenticationError } from '@/services/user.service'
import TokenService from '@/services/storage.service'
import router from '@/router'

const state = {
    authenticating: false,
    resetting: false,
    accessToken: TokenService.getToken(),
    authenticationErrorCode: 0,
    authenticationError: '',
    userRoles: '',
    userId: '',
}

const getters = {
    loggedIn: (state) => {
        // return localStorage.getItem('access_token') ? true : false;
        
        return state.accessToken ? true : false
    },
    isActivity: () => {
        const activityRole = process.env.NODE_ENV == "development" ? "74" : "37";
        const userRoles = state.userRoles;
        // console.log(userRoles);
        if (userRoles) {
            return userRoles.split(';').indexOf(activityRole) >= 0
        } else {
            return false;
        }
    },
    isMemberAdmin: () => {
        const memberRole = process.env.NODE_ENV == "development" ? "73" : "36";
        const userRoles = state.userRoles
        // console.log(userRoles, memberRole);
        // console.log(userRoles.split(';').indexOf(memberRole));
        if (userRoles) {
            return userRoles.split(';').indexOf(memberRole) >= 0
        } else {
            return false;
        }
    },
    getUserId: (state) => {
        // console.log(state.user_id);
        if (state.userId != '') {
            return state.userId;
        } else {
            return false;
        }
    },
    authenticationErrorCode: (state) => {
        return state.authenticationErrorCode
    },

    authenticationError: (state) => {
        return state.authenticationError
    },

    authenticating: (state) => {
        return state.authenticating
    },

    resetting: state => state.resetting
}

const actions = {
    async login({commit}, {email, password}) {
        
        commit('loginRequest');

        try {
            const data = await UserService.login(email, password);
            commit('loginSuccess', data);

            router.push(router.history.current.query.redirect || '/');

            return true
        } catch (e) {
            if (e instanceof AuthenticationError) {
                commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
            }

            return false
        }
    },

    async resetpw({commit}, {email}) {
        
        commit('resetpwRequest');

        try {
            const data = await UserService.resetPw(email);
            commit('resetpwSuccess', data);

            router.push('/');

            return true
        } catch (e) {
            if (e instanceof AuthenticationError) {
                commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
            }

            return false
        }
    },

    

    logout({ commit }) {
        UserService.logout()
        commit('logoutSuccess')
        router.push('/login')
    }
}

const mutations = {
    loginRequest(state) {
        state.authenticating = true,
        state.authenticationError = '',
        state.authenticationErrorCode = 0
    },

    loginSuccess(state, data) {
        state.accessToken = data.access_token,
        state.userRoles = data.user.user_roles,
        state.userId = data.user.user_id,
        state.authenticating = false;
    },
    resetpwRequest(state) {
        state.resetting = true,
        state.authenticationError = '',
        state.authenticationErrorCode = 0
    },
    resetpwSuccess(state) {
        state.resetting = false;
    },

    loginError(state, {errorCode, errorMessage}) {
        state.authenticating = false
        state.authenticationErrorCode = errorCode
        state.authenticationError = errorMessage
    },

    logoutSuccess(state) {
        state.accessToken = '',
        state.userRoles = '',
        state.userId = ''
    }
}

// export const auth = {
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}